import { createMuiTheme } from '@material-ui/core/styles';

const Theme = createMuiTheme({
    palette: {
        primary: { main: '#2d324f' },
        secondary: { main: '#11cb5f' },
    },
    typography: {
        fontFamily: [
            'Roboto',
            'Helvetica',
            'Arial'
        ]
    }
});

export default Theme;
